/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Гражданство
 * @export
 * @interface CitizenshipDto
 */
export interface CitizenshipDto {
    /**
     * Двухбуквенный код страны гражданства
     * @type {string}
     * @memberof CitizenshipDto
     */
    code: string;
    /**
     * Название страны гражданства
     * @type {string}
     * @memberof CitizenshipDto
     */
    name: string;
    /**
     * Двухбуквенный идентификатор локали
     * @type {string}
     * @memberof CitizenshipDto
     */
    local: string;
}

/**
 * Check if a given object implements the CitizenshipDto interface.
 */
export function instanceOfCitizenshipDto(value: object): value is CitizenshipDto {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('local' in value) || value['local'] === undefined) return false;
    return true;
}

export function CitizenshipDtoFromJSON(json: any): CitizenshipDto {
    return CitizenshipDtoFromJSONTyped(json, false);
}

export function CitizenshipDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CitizenshipDto {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'name': json['name'],
        'local': json['local'],
    };
}

  export function CitizenshipDtoToJSON(json: any): CitizenshipDto {
      return CitizenshipDtoToJSONTyped(json, false);
  }

  export function CitizenshipDtoToJSONTyped(value?: CitizenshipDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'name': value['name'],
        'local': value['local'],
    };
}

